import styled from 'styled-components';
import * as antd from 'antd';

export const SelectDocType = styled((props) => <antd.Select {...props} />)`
 width: 280px;
 margin-right: 20px;
`;

export const ButtonDownload = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 width: 180px;
 margin-left: 10px;
 color: #313149;
 font-size: 16px;
 line-height: 18px;
`;

export const SubmitButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 color: #313149;
 margin-left: 40px;
 margin-top: -5px;
 width: 180px;
 font-size: 18px;
 line-height: 18px;
`;

export const Modal = styled(antd.Modal)`
 .ant-modal-content {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
 }
 .ant-modal-footer {
  text-align: center;
  border: none;
 }
 .ant-modal-body {
  padding: 20px 20px 0 20px;
 }
`;

export const ButtonCancel = styled(antd.Button)`
 margin: auto;
 width: 150px;
 font-size: 18px;
 line-height: 18px;
 color: #2b314f;
`;
